var $de07b4eb19bfbc3a$exports = {};
$de07b4eb19bfbc3a$exports = {
    "removeButtonLabel": `Odstrani`,
    "removeDescription": `Pritisnite Delete, da odstranite oznako.`
};


export {$de07b4eb19bfbc3a$exports as default};
//# sourceMappingURL=sl-SI.mjs.map
